import React from 'react';

export type FormatValue = (value: number) => string;

export type FormatGroupName = (value: string) => React.ReactNode;
